<template>
<div class="chapter">
<div class="inner_page">
<div id="eve-of-warfare-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="body"> </p>
<p class="h1"><img alt="* * *" src="images/chapter-opener-warfare.jpg" width="450px"/></p>
<p class="h1">TABLE OF CONTENTS</p>
<p class="body"> </p>
<p class="toc"><a href="#/eveofwarfare3">Chapter 1</a></p>
<p class="toc"><span href="#/eveofwarfare4" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc"><span href="#/eveofwarfare5" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span href="#/eveofwarfare6" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span href="#/eveofwarfare7" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/eveofwarfare8" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eveofwarfaretoc.vue?055ce2a3